import { render } from "./assessmentReportCom.vue?vue&type=template&id=ada25b94"
import script from "./assessmentReportCom.vue?vue&type=script&lang=js"
export * from "./assessmentReportCom.vue?vue&type=script&lang=js"

import "./assessmentReportCom.vue?vue&type=style&index=0&id=ada25b94&lang=scss"

import exportComponent from "D:\\myWork\\SAAS\\Group-Carwins-H5-1.0\\carwins-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__